module.exports = __webpack_public_path__ + "img/HQ-OA-360V05NL_ALL.fb7b7b75.jpg";